<template>
    <div class="main-container">
        
        <!-- Navbar section -->
		<HeaderPayment />

		<!-- hero section -->
		<HeroPayment />

        <!-- payment feature section -->
        <PaymentFeatureSection />

        <!-- payment step section -->
        <PaymentStep />

        <!-- payment pricing section -->
        <PaymentPricingWrapper />

        <CtaOne />

        <!-- newsletter section -->
        <!-- <PaymentNewsletter /> -->

        <!-- brand carousel -->
        <!-- <CarouselStartup /> -->

        <!-- about us section  -->
        <AboutUs />

        <!-- call to action section  -->
        <CallToAction />

        <!-- contact us section -->
        <!-- <ContactUs /> -->

        <!-- footer section -->
        <FooterMain />

    </div>
</template>

<script>
    import 'bootstrap/dist/css/bootstrap.css'
    import 'swiper/dist/css/swiper.css'
    import '@/assets/static-style/style.scss';
    import 'slick-carousel/slick/slick.css'

    import HeaderPayment from './components/sections/HeaderPayment.vue'
    import HeroPayment from './components/sections/HeroPayment.vue'
    import PaymentFeatureSection from './components/sections/PaymentFeatureSection.vue'
    import PaymentStep from './components/sections/PaymentStep.vue'
    import PaymentPricingWrapper from './components/sections/PaymentPricingWrapper.vue'
    import CtaOne from "./components/sections/CtaOne";
    // import PaymentNewsletter from './components/sections/PaymentNewsletter.vue'
    // import CarouselStartup from './components/CarouselStartup.vue'
    import AboutUs from './components/sections/AboutUs.vue'
    import CallToAction from './components/sections/CallToAction.vue'
    import ContactUs from './components/sections/ContactUs.vue'
    import FooterMain from './components/FooterMain.vue'

    export default {
        name: 'app',
        components: {
            HeaderPayment,
            HeroPayment,
            PaymentFeatureSection,
            PaymentStep,
            PaymentPricingWrapper,
            CtaOne,
            // PaymentNewsletter,
            // CarouselStartup,
            AboutUs,
            CallToAction,
            ContactUs,
            FooterMain
        }
    }
</script>

<style lang="scss">
    @import '@/assets/static-style/_variabls.scss';
    @import '@/assets/scss/page-section/_payment.scss';
</style>

<style>
@media (min-width: 992px) {
    .order-lg-1 {
        order: 1 !important;
    }
    .order-lg-2 {
        order: 2 !important;
    }
}
</style>
